module.exports = __webpack_public_path__ + "static/media/9ft-ceiling.33b00de6.svg";